/* eslint-disable @typescript-eslint/no-explicit-any */
import type { SortType } from "./hooks/useTableParams";

export const createSortHandler =
  (
    setTableParams: (updater: (prev: any) => any) => void,
    field: string,
    useUpperCase = false,
    directionKey: "sortDirection" | "sortOrder" = "sortDirection"
  ) =>
  (direction: SortType) => {
    const normalizedDirection =
      direction && useUpperCase
        ? (direction.toUpperCase() as SortType)
        : direction;
    setTableParams(prev => ({
      ...prev,
      sortBy: normalizedDirection ? field : undefined,
      [directionKey]: normalizedDirection || undefined,
      offset: 0,
    }));
  };
